import React from 'react';
import PropTypes from 'prop-types';

class Flag extends React.Component {
  render() {
    const { children, fallBack, flags, name } = this.props;
    return flags[name] ? children : fallBack;
  }
}

Flag.propTypes = {
  children: PropTypes.node,
  fallBack: PropTypes.node,
  flags: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
};

Flag.defaultProps = {
  children: null,
  fallBack: null,
};

export default Flag;
